import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * 啟用物料單位。
 * `POST /mtr/{mtrId}/units/{mtrUnitId}/activate`；body 僅 `{ updatedAt }`。
 *
 * @param {string} mtrId
 * @param {string} mtrUnitId
 * @param {{ updatedAt?: string }} [payload]
 */
export async function activateMtrUnit(mtrId, mtrUnitId, payload = {}) {
  const { data: raw } = await request.post(
    `/mtr/${mtrId}/units/${mtrUnitId}/activate`,
    keysToSnake({ updatedAt: payload.updatedAt }),
  );
  return parseVer4DetailResponse(raw);
}
